import { Tab, Tabs } from '@mui/material';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Select, TextInput, TitleBar, View } from '../components/index.js';
import { getAllEvents, getRandomEvents, rollEvent } from '../logic/events.js';
import * as actions from '../redux/actions/actions.js';
import MonsterTable from './MonsterTable.js';

const allEvents = getAllEvents();

const RollForEvents = ({}) => {
  const [tab, setTab] = useState(0);
  const [infos, setInfos] = useState([]);
  const [amount, setAmount] = useState(2);
  const [manualEvent, setManualEvent] = useState('');
  // Guards against re-entrant rolls (e.g. clicking the roll button twice very
  // fast), which previously crashed the screen.
  const isRolling = useRef(false);

  const getInfo = () => {
    if (isRolling.current) return;
    isRolling.current = true;
    try {
      const events = getRandomEvents({ amount });
      setInfos(events);
    } catch (e) {
      console.error('Failed to roll events', e);
    } finally {
      isRolling.current = false;
    }
  };

  const addManualEvent = () => {
    if (manualEvent === '' || manualEvent === undefined || manualEvent === null) return;
    if (isRolling.current) return;
    isRolling.current = true;
    try {
      const event = allEvents[manualEvent];
      if (!event) return;
      setInfos((prev) => [...prev, rollEvent(event)]);
    } catch (e) {
      console.error('Failed to add event', e);
    } finally {
      isRolling.current = false;
    }
  };

  const clearEvents = () => setInfos([]);

  const eventOptions = allEvents
    .map((event, index) => ({ _id: index, label: event.encounterName || `Event ${index + 1}` }))
    .filter((option) => option.label && option.label.trim() !== '');

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={'Play'}>
      <Tabs value={tab} onChange={(event, value) => setTab(value)}>
        <Tab label="Roll" />
        <Tab label="All Events" />
      </Tabs>
      <br></br>

      {tab === 0 && (
        <View>
          <View style={{ flexDirection: 'row', maxHeight: '80px', alignItems: 'center', gap: 10 }}>
            <TextInput title="Event amount" variant="outlined" value={amount} onChange={setAmount} />
            <Button style={{ maxWidth: '120px' }} onPress={getInfo} text={'Load Event'} />
          </View>

          <br></br>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <View style={{ minWidth: '220px' }}>
              <Select titulo={'Add event manually'} value={manualEvent} lista={eventOptions} onChange={setManualEvent} />
            </View>
            <Button style={{ maxWidth: '120px' }} onPress={addManualEvent} text={'Add Event'} />
            <Button style={{ maxWidth: '120px' }} onPress={clearEvents} text={'Clear'} />
          </View>

          <br></br>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Behavior</th>
                <th>Extra</th>
              </tr>
            </thead>
            <tbody>
              {infos &&
                infos?.map((obj, index) => {
                  return (
                    <tr key={index}>
                      <td>{obj.encounterName}</td>
                      <td>{obj.quickDescription}</td>
                      <td>{obj.behavior}</td>
                      <td>{extraInfoTable({ obj })}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <br></br>
          {infos &&
            infos?.map((obj, index) => {
              return <View key={index}>{extraInfo({ obj })}</View>;
            })}
        </View>
      )}

      {tab === 1 && (
        <View>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Behavior</th>
              </tr>
            </thead>
            <tbody>
              {allEvents.map((obj, index) => {
                return (
                  <tr key={index}>
                    <td>{obj.encounterName}</td>
                    <td>{obj.quickDescription}</td>
                    <td style={{ whiteSpace: 'pre-line' }}>{obj.behavior}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </View>
      )}
    </TitleBar>
  );
};

const extraInfoTable = ({ obj }) => {
  if (obj.key === 'merchant') {
    return (
      <View>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
              <th>Discount</th>
              <th>Final Price</th>
            </tr>
          </thead>
          <tbody>
            {obj.extraInfo.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.item}</td>
                  <td>{item.purchasePrice}</td>
                  <td>{item.discount}</td>
                  <td>{item.finalPrice}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </View>
    );
  }

  if (obj.key === 'wizard') {
    return (
      <View>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Discount</th>
              <th>Final Price</th>
            </tr>
          </thead>
          <tbody>
            {obj.extraInfo.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.spell}</td>
                  <td>{item.discount}</td>
                  <td>{item.finalPrice}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </View>
    );
  }
  return <View></View>;
};

const extraInfo = ({ obj }) => {
  if (obj.key === 'merchant') {
    return (
      <View>
        <br></br>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>effects</th>
            </tr>
          </thead>
          <tbody>
            {obj.extraInfo.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.item}</td>
                  <td>{item.effects}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </View>
    );
  }
  if (obj.key === 'wizard') {
    return (
      <View>
        <br></br>
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Spell</th>
              <th>School</th>
              <th>Casting Target</th>
              <th>Category/Range</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {obj.extraInfo?.map((obj, index) => {
              return (
                <tr key={index}>
                  <td>{obj.spell}</td>
                  <td>{obj.school}</td>
                  <td>{obj.castingvalue}</td>
                  <td>{obj.category}</td>
                  <td>{obj.desc}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br></br>
      </View>
    );
  }

  if (obj.key === 'warband') {
    return (
      <View>
        <br></br>
        {MonsterTable({ monsters: obj.extraInfo.monsters })}
      </View>
    );
  }

  return <View></View>;
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  story: state.Reducer.story,
});

const mapDispatchToProps = (dispatch) => ({
  setStory: (story) => dispatch(actions.setStory(story)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(RollForEvents);
